import dayjs from 'dayjs';
import { uipApiInstance } from '../../services';

export interface ResourceDocument {
    _id: string;
    title: string;
    description: string;
    fileName: string;
    filePath: string;
    fileUpdatedDate: string;
    language: string;
    order: number;
    pageName: string;
    resourceType: string;
    tag: string;
    duration?: string;
}

export const getResourceDocuments = async (tenant: string): Promise<ResourceDocument[]> => {
    const response = await uipApiInstance.get('/api/advice/getresourcedocuments', { params: { tenant } });
    return response.data?.documents ?? [];
};

const BADGE_LABEL_KEYS: Record<string, string> = {
    insight: 'RESOURCES_BADGE_INSIGHT',
    tutorial: 'RESOURCES_BADGE_TUTORIAL',
    pdf: 'RESOURCES_BADGE_PDF',
    video: 'RESOURCES_BADGE_VIDEO'
};

const capitalize = (value: string) => value.charAt(0).toUpperCase() + value.slice(1);

/**
 * Splits a document tag like "insight - PDF" into its type ("insight") and format ("PDF")
 * and returns the translated badge labels, falling back to the capitalised raw value.
 */
//eslint-disable-next-line no-unused-vars
export const getBadgeLabels = (tag: string, t: (key: string) => string) => {
    const [type = '', format = ''] = (tag || '').split('-').map((part) => part.trim());
    const translate = (value: string) => {
        const key = BADGE_LABEL_KEYS[value.toLowerCase()];
        return key ? t(key) : capitalize(value);
    };
    return { typeLabel: translate(type), formatLabel: translate(format) };
};

// Formats the API date as DD/MM/YYYY.
export const formatDocumentDate = (value: string) => {
    const date = dayjs(value);
    return date.isValid() ? date.format('DD/MM/YYYY') : value;
};
